import { render, staticRenderFns } from "./NodeTypePicker.vue?vue&type=template&id=564916ca&scoped=true&"
import script from "./NodeTypePicker.vue?vue&type=script&lang=js&"
export * from "./NodeTypePicker.vue?vue&type=script&lang=js&"
import style0 from "./NodeTypePicker.vue?vue&type=style&index=0&id=564916ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564916ca",
  null
  
)

export default component.exports